import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["moldType"]

  connect() {
    console.log("Mold Form controller connected")
    // Initial toggle
    this.toggleWickSection()

    // Also toggle when accordions are opened (in case they weren't in DOM yet)
    document.addEventListener('shown.bs.collapse', () => {
      this.toggleWickSection()
    })
  }

  toggleWickSection() {
    const moldType = this.moldTypeTarget.value
    console.log("Toggling wick section, mold type:", moldType)

    // Search within the form element
    const wickSections = this.element.querySelectorAll('[data-wick-section]')
    console.log("Found wick sections:", wickSections.length)

    wickSections.forEach(section => {
      if (moldType === 'jesmonite') {
        section.style.display = 'none'
        console.log("Hiding wick section")
      } else {
        section.style.display = 'block'
        console.log("Showing wick section")
      }
    })
  }
}

